module.exports = __webpack_public_path__ + "static/media/cert_127.48bc3f1c.jpg";